import React, {ChangeEvent, useState} from "react";

import {Button, Input} from "@chakra-ui/react";

import {TeqGroupDto} from "./api/dtos";

import TeqGroupGauge from "./teq-group-gauge";

function AutomatedTeqGroupResult() {
    const [value, setValue] = useState<string>("");
    const [response, setResponse] = useState<TeqGroupDto | null>(null);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;

        setValue(inputValue);
    }

    const onSubmit = async () => {
        if (value) {
            const parsedResponse: TeqGroupDto = JSON.parse(value);

            setResponse(parsedResponse);
        }
    }

    if (!response) {
        return (
            <form>
                <Input value={value}
                       onChange={handleChange}
                       name="input"/>

                <Button name="submit" onClick={onSubmit} type="submit">Submit</Button>
            </form>
        );
    } else {
        return (
            <div id="diagnostic-results">
                <TeqGroupGauge teq={response}/>
            </div>
        )
    }
}


export default AutomatedTeqGroupResult;
